/**
 * Checks for the presence of 'data' and 'success' keys in an
 * API response.
 *
 * @param res
 * @returns {boolean}
 */
export function responseIsSuccessful(res) {
  return !!res && !!res.data && !!res.data.success;
}

/**
 * Returns the message from an Axios error response.
 *
 * @param err
 * @returns {string}
 */
export function getAxiosErrorMessage(err) {
  if (err.response.status === 500) {
    return "Server Error";
  }
  return err.response.data.error || err.response.data.message;
}
